import {
  createHintEscalationState,
  createRetryFeedback,
  createSuccessFeedback,
  type ActivityFeedback,
  type HintEscalationState
} from "../../feedback";
import {
  calculateChoiceMatchCompletionScore,
  type ChoiceMatchCompletionScore
} from "./scoring";

export type ChoiceMatchStatus = "active" | "complete";

export interface ChoiceMatchProgressState {
  readonly status: ChoiceMatchStatus;
  readonly feedback: ActivityFeedback | null;
  readonly hintState: HintEscalationState;
  readonly retryCount: number;
  readonly promptReplayCount: number;
  readonly completionScore: ChoiceMatchCompletionScore | null;
}

export function createChoiceMatchProgressState(): ChoiceMatchProgressState {
  return {
    status: "active",
    feedback: null,
    hintState: createHintEscalationState(),
    retryCount: 0,
    promptReplayCount: 0,
    completionScore: null
  };
}

export function requestPromptReplay(
  state: ChoiceMatchProgressState
): ChoiceMatchProgressState {
  return {
    ...state,
    promptReplayCount: state.promptReplayCount + 1
  };
}

export function createNeutralRetryProgress(
  state: ChoiceMatchProgressState
): ChoiceMatchProgressState {
  const transition = createRetryFeedback(state.hintState);

  return {
    ...state,
    feedback: transition.feedback,
    hintState: transition.hintState,
    retryCount: state.retryCount + 1
  };
}

export function completeChoiceMatchProgress(
  state: ChoiceMatchProgressState,
  successfulChecks: number
): ChoiceMatchProgressState {
  return {
    ...state,
    status: "complete",
    feedback: createSuccessFeedback(),
    completionScore: calculateChoiceMatchCompletionScore(
      successfulChecks,
      state.retryCount,
      state.hintState.hintCount
    )
  };
}
